import { Form, Row, Col, Button} from 'react-bootstrap'
import Colors from '../../../constants/Colors'
import { validateNumberOnly } from '../utils'

const KYCSearch = ({ userNo, setUserNo, phoneNo, setPhoneNo , onEnterSearch, onClickClear }) => {
  return (
    <Form>
        <Form.Group>
          <Row>
            <Col sm={12} md={4}>
              <input
                className="form-control"
                style={{ color: Colors.DARK_GREY }}
                type="text"
                placeholder="รหัสสมาชิก"
                onChange={(e) => {
                  setUserNo(e.target.value)
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    onEnterSearch(e)
                  }
                }}
                defaultValue={userNo}
                value={userNo}
              />
            </Col>
            <Col sm={12} md={4}>
              <input
                className="form-control"
                style={{ color: Colors.DARK_GREY }}
                type="text"
                placeholder="เบอร์โทรศัพท์"
                maxLength={10}
                onChange={(e) => {
                  validateNumberOnly(e.target.value) && setPhoneNo(e.target.value)
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    onEnterSearch(e)
                  }
                }}
                defaultValue={phoneNo}
                value={phoneNo}
              />
            </Col>
            <Col sm={12} md={4}>
              <Row>
                <Col md={6} lg={0}></Col>
                <Col md={6} lg={12}>
                  <Button
                    variant="danger light"
                    className="w-50"
                    onClick={onClickClear}
                  >
                    ล้างตัวกรอง
                  </Button>
                  <Button
                    variant="primary light"
                    className="w-50"
                    onClick={onEnterSearch}
                  >
                    ค้นหา
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form.Group>
      </Form>
  )
}

export default KYCSearch
